import All from "./All";
import One from "./One";

export default {
	All,
	One
};
